const config = {
  //Production
  baseURL: "https://benetworks-api-dev-x7gq7zmvhq-uc.a.run.app/v1/",
  //Development
  //baseURL: "http://localhost:9000/v1/",
};

export default config;
